import { useEffect, useState } from "react";
import { useAuthedApi } from "@/api/useAuthedApi";

/** Whether conversations-as-knowledge is on for this deployment. Its routes
 *  answer 404 while the backend flag is off and /v1/config does not carry the
 *  flag, so a probe decides. Fails closed: until the probe answers, or when it
 *  fails, the controls stay hidden — a missing menu item beats one that 404s. */
export function useConversationKnowledgeEnabled(): boolean {
  const { conversationKnowledge } = useAuthedApi();
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!conversationKnowledge) return;
    let cancelled = false;
    conversationKnowledge.enabled().then(
      (on) => {
        if (!cancelled) setEnabled(on);
      },
      (e) => {
        console.warn("conversation knowledge probe failed", e);
        if (!cancelled) setEnabled(false);
      },
    );
    return () => {
      cancelled = true;
    };
  }, [conversationKnowledge]);
  return enabled;
}
